import React, { useEffect, useState } from "react";
import axios from "axios";
import { file_path } from "./environment";

function Select({ guide }) {

    function onPublicationSelected(event) {
        const publication_id = event.target.value;
        window.location.href = `/feedback/${publication_id}`;
    }

    const options = guide.publications.sort((p1, p2) => parseInt(p2.id) - parseInt(p1.id)).map((pub) => {
        return <option value={pub.name} key={pub.name}>{pub.name}</option>
    });

    return (
        <select key={guide.id} id={guide.id} onChange={onPublicationSelected}>
            <option value="" key="none"></option>
            {options}
        </select>
    );
}

function Guides({ guides }) {
    const guideList = Object.entries(guides).sort(([idA], [idB]) => parseInt(idA) - parseInt(idB)).map(([id, guide]) => {
        return (
            <div>
                <h3>{guide.name}</h3>
                <Select guide={guide} />
            </div>
        );
    });

    return (
        guideList
    );
}

export default function Feedback() {
    const [guides, setGuides] = useState([]);

    useEffect(() => {
        axios.get(file_path('/feedback.json')).then((res) => {
            setGuides(res.data);
        });
    }, []);

    useEffect(() => {
        document.title = "Client Feedback";
    }, []);

    return (
        <div className="container">

            <div className="body">
                <h2>Client Feedback</h2>
                <Guides guides={guides} />
            </div>
        </div>
    );
}
